<template>
  <div class="mt-6 -mb-1 flex flex-wrap">
    <template v-for="(link, key) in links">
      <div v-if="link.url === null" :key="key" class="mr-1 mb-1 w-10 h-10 flex items-center justify-center text-sm rounded-full text-gray-500" :class="{ 'ml-auto': link.label === 'Next' }">
        <span v-if="link.label === 'Previous' || link.label === '&laquo;'">
          <svg class="w-10 h-10" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width=".5" viewBox="0 0 24 24" stroke="currentColor">
            <path d="M15 19l-7-7 7-7"></path>
          </svg>
        </span>
        <span v-else-if="link.label === 'Next' || link.label === '&raquo;'">
          <svg class="w-10 h-10" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width=".5" viewBox="0 0 24 24" stroke="currentColor">
            <path d="M9 5l7 7-7 7"></path>
          </svg>
        </span>
        <span v-else>
          {{ link.label }}
        </span>
      </div>
      <inertia-link v-else :key="key" class="mr-1 mb-1 w-10 h-10 flex items-center justify-center text-sm rounded-full hover:a10-pagination-link-hover" :class="{ 'a10-pagination-link-active': link.active, 'ml-auto': link.label === 'Next' }" :href="link.url">
        <span v-if="link.label === 'Previous' || link.label === '&laquo;'">
          <svg class="w-10 h-10" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width=".5" viewBox="0 0 24 24" stroke="currentColor">
            <path d="M15 19l-7-7 7-7"></path>
          </svg>
        </span>
        <span v-else-if="link.label === 'Next' || link.label === '&raquo;'">
          <svg class="w-10 h-10" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width=".5" viewBox="0 0 24 24" stroke="currentColor">
            <path d="M9 5l7 7-7 7"></path>
          </svg>
        </span>
        <span v-else>
          {{ link.label }}
        </span>
      </inertia-link>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    links: Array,
  },
}
</script>
